<template lang="pug">
.custom-date-picker-single
  //- input(
  //-   type='date'
  //-   :value='value'
  //-   @input='$emit(`input`, $event.target.value)'
  //- )
  button.rounded.transparent-button.small(@click='showModal')
    .d-flex.align-items-center.text-medium.px-1
      span {{ formattedPreviewText }}
      i.fa.fa-angle-down.ml-2(style='color: #0092C9')

  .upa-modal
    modal(
      :name='modalName'
      width='384px' height='600px'
      transition='modal-transition'
      :clickToClose='false'
    )
      .d-flex.flex-column.h-100
        .custom-header.d-flex.sticky-top
          .d-flex.align-items-center.px-4.flex-fill
            .text-title.mt-2 เลือกพนักงาน
          button.transparent-button.no-scaling(@click='hideModal(false)')
            i.fa.fa-times(style='font-size: 24px; padding: 12px 16px;')

        SellerChooserCore.flex-fill.not-scrollable(
          v-model='sellers'
          @selectedIndexChanged='selectedSellersIndex = $event'
          :selectedSellersIndex='selectedSellersIndex'

          :multiSelect='true'
          :hideTitle='true'
        )
          //- @sellersSelected='selectSeller'

        hr.m-0
        .px-4.py-3
          .d-flex.justify-content-center
            button.btn.btn-secondary.flex-fill.px-2(@click='selectEveryone()')
              | เลือกพนักงานทุกคน
            button.btn.btn-upa-secondary.flex-fill.ml-3(@click='hideModal(true)')
              | บันทึก
          //- .d-flex.justify-content-center.pt-2
          //-   button.btn.btn-upa-secondary.flex-fill(@click='hideModal(true)')
          //-     | บันทึก
          //-   button.btn.btn-secondary.flex-fill.ml-4(@click='hideModal(false)')
          //-     | ยกเลิก

</template>

<script>
import SellerChooserCore from '@/components/_admin/seller-records/panels/history/SellerChooserCore.vue';

export default {
  props: {
    value: {
      default: () => ({}),
    },
  },
  watch: {
    sellers() {
      // this.hideModal(true);
    },
  },
  computed: {
    formattedPreviewText() {
      if (this.value && this.value.length > 0) {
        if (this.value.length === 1) {
          return this.value[0].name;
        }
        return `เลือกแล้ว ${this.value.length} คน`;
      }
      return 'พนักงานทุกคน';
      // if (this.selectedSellersIndex && this.selectedSellersIndex.length > 0) {
      //   return this.selectedSellersIndex.map(elm => elm);
      // }
      // return 'พนักงานทุกคน';
    },
  },
  data: () => ({
    sellers: [],
    selectedSellersIndex: [],

    modalName: '',
  }),
  mounted() {
    // if (!this.value) {
    //   const DEFAULT_DATE = this.$moment().startOf('month').toDate();
    //   this.$emit('input', DEFAULT_DATE);
    // }

    const randomId = Math.random() * 10000000000;
    this.modalName = `seller-picker-${Math.round(randomId)}`;
  },
  methods: {
    showModal() {
      this.sellers = this.value;
      // this.endDate = this.value.to;
      this.$modal.show(this.modalName);
    },
    hideModal(saveValue = true) {
      if (saveValue) {
        this.$emit('input', this.sellers);
      }
      this.$modal.hide(this.modalName);
    },

    selectEveryone() {
      this.sellers = [];
      this.selectedSellersIndex = [];
      this.hideModal(true);
    },

    selectSeller(e) {
      this.sellers = e;
    },
  },
  components: {
    SellerChooserCore,
  },
};
</script>

<style lang="scss">
// .custom-date-picker-single {}
.custom-header {
  background: #fff;
}
</style>
